import { computed, type ComputedRef } from 'vue'

export function useTooManyEnrollmentsMessage(
    totalEnrollmentCount: ComputedRef<number>,
    waitlistEnabled: ComputedRef<boolean>,
    capacityInformation: ComputedRef<{
        bookingStatusAvailable: {
            customerName: string
            session: {
                sessionId: string
                startDate: string
            } | null
            overrideCapacityConstraints: boolean
        }[]
        enrollments: number
        isWaitlistFull: boolean
    } | null>
) {
    return computed(() => {
        if (capacityInformation.value === null) {
            return null
        }

        const actualAvailability = Math.max(
            capacityInformation.value.enrollments,
            0
        )

        if (totalEnrollmentCount.value > actualAvailability) {
            let message = 'You have selected '
            if (totalEnrollmentCount.value === 1) {
                message += totalEnrollmentCount.value + ' participant'
            } else {
                message += totalEnrollmentCount.value + ' participants'
            }

            if (actualAvailability === 0) {
                message += ', but no spaces are available'
            } else if (actualAvailability === 1) {
                message +=
                    ', but only ' + actualAvailability + ' space is available'
            } else if (actualAvailability > 1) {
                message +=
                    ', but only ' + actualAvailability + ' spaces are available'
            }

            // If we have a waitlist, we can prompt to add them
            if (waitlistEnabled.value) {
                // This means there is a session they can book into and override
                // capacity constraints
                if (
                    capacityInformation.value.bookingStatusAvailable.some(
                        status => status.overrideCapacityConstraints
                    )
                ) {
                    return null
                }

                // If the selected course waitlist is full
                if (capacityInformation.value.isWaitlistFull) {
                    message += '. The waitlist is currently full.'
                }
                // If there is still space in the course
                else if (actualAvailability === 1) {
                    message +=
                        '. You may book ' +
                        actualAvailability +
                        ' participant and then return here to join the waitlist.'
                } else if (actualAvailability > 1) {
                    message +=
                        '. You may book ' +
                        actualAvailability +
                        ' participants and then return here to join the waitlist.'
                }
                // We can join the waitlist
                else {
                    message += '. Join the waitlist below.'
                }
            }

            return message
        }

        return null
    })
}
